export default __webpack_public_path__ + "static/media/rotation.adf90094.svg";